import { Grid } from '@mui/material';
import { RoutalLoader } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import * as routing from '../../constants/Routing';
import { User } from '../../domain/user/User';
import { useRetrieveActiveProject } from '../../hooks/project/useRetrieveActiveProject';
import { useRetrieveFlatProjects } from '../../hooks/project/useRetrieveFlatProjects';
import { Customers } from '../customers';
import { Drivers } from '../drivers';
import { PlannerStops } from '../stops/PlannerStops';
import { ProjectAnalytics } from './../analytics/ProjectAnalytics';
import { Planner } from './../planner';
import { ProjectSettings } from './../project-settings/ProjectSettings';

type ProjectComponentProps = {
  user?: User;
};

export const ProjectComponent = ({ user }: ProjectComponentProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { run: getProjects } = useRetrieveFlatProjects({ user });

  useEffect(() => {
    getProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!activeProject) {
    return (
      <Grid
        item
        container
        direction="column"
        style={{ height: `100%`, width: `100%` }}
        alignItems="center"
        justifyContent="center"
      >
        <RoutalLoader />
      </Grid>
    );
  }

  return (
    <Routes>
      <Route index element={<Navigate to={routing.PLANNER.PLANS.replace(`:projectId`, activeProject.id)} />} />
      <Route path="/planner/*" element={<Planner />} />
      <Route path="/stops/*" element={<PlannerStops />} />
      <Route path="/drivers/*" element={<Drivers />} />
      <Route path="/customers/*" element={<Customers />} />
      <Route path="/analytics/*" element={<ProjectAnalytics />} />
      <Route path="/project_settings/*" element={<ProjectSettings />} />
      <Route
        path="*"
        element={
          <Navigate
            to={routing.PLANNER.ROOT.replace(`:projectId`, activeProject.id ?? user?.default_project_id ?? ``)}
          />
        }
      />
    </Routes>
  );
};
